module.exports = __webpack_public_path__ + "img/markito.0a443203.jpg";